import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'

import { defineRouter } from '#q-app/wrappers'

import { ensureAdminRoutes, isAdminPath } from './loadAdminRoutes'
import {
  ensureCustomerPanelRoutes,
  isCustomerPanelPath,
} from './loadCustomerPanelRoutes'
import routes from './routes'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  // Server receives paths with prefix already stripped by reverse proxy,
  // so it must NOT use a base path. Client browser URL includes the prefix.
  const historyBase = process.env.SERVER
    ? undefined
    : process.env.VUE_ROUTER_BASE

  const Router = createRouter({
    history: createHistory(historyBase),
    routes,
    scrollBehavior: () => ({ left: 0, top: 0 }),
  })

  Router.beforeEach(async (to) => {
    if (isAdminPath(to.path)) {
      const added = await ensureAdminRoutes(Router)

      if (added) {
        return to.fullPath
      }
    }

    if (isCustomerPanelPath(to.path)) {
      const added = await ensureCustomerPanelRoutes(Router)

      if (added) {
        return to.fullPath
      }
    }
  })

  return Router
})
